'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies */


var htmlToReactParser = new _htmlToReact2.default.Parser();

var UASubSection = function (_React$Component) {
  _inherits(UASubSection, _React$Component);

  function UASubSection() {
    _classCallCheck(this, UASubSection);

    return _possibleConstructorReturn(this, (UASubSection.__proto__ || Object.getPrototypeOf(UASubSection)).apply(this, arguments));
  }

  _createClass(UASubSection, [{
    key: 'render',

    // componentDidMount() {
    //   window.addEventListener('scroll', this.handleScroll);
    // }

    // componentWillUnmount() {
    //   window.removeEventListener('scroll', this.handleScroll);
    // }

    // handleScroll = () => {
    //   const { currentSubSectionIndex, index, setSubSection, scrollDirection } = this.props;
    //   if (this.subSectionRef) {
    //     const subSectionTop = this.subSectionRef.getBoundingClientRect().top;
    //     const headerOffset = 62;
    //     const bannerOffset = 112;
    //     const topOffset = headerOffset + bannerOffset;
    //     if (scrollDirection === 'down' && subSectionTop < topOffset && currentSubSectionIndex < index) {
    //       setSubSection(index);
    //     } else if (scrollDirection === 'up') {
    //       if (currentSubSectionIndex === index + 1) {
    //         if (subSectionTop > (topOffset - this.subSectionRef.scrollHeight)) {
    //           setSubSection(index - 1);
    //         }
    //       }
    //     }
    //   }
    // };

    value: function render() {
      var _this2 = this;

      var _props = this.props,
          anchorLink = _props.anchorLink,
          headline = _props.headline,
          paragraph = _props.paragraph,
          table = _props.table,
          paragraph2 = _props.paragraph2,
          sectionIndex = _props.sectionIndex,
          index = _props.index;

      var id = anchorLink && anchorLink.text ? anchorLink.text : 'UASubSection-' + sectionIndex + '-' + index;
      return _react2.default.createElement(
        'div',
        {
          // id={id}
          ref: function ref(el) {
            _this2.subSectionRef = el;
          },
          className: 'ua-sub-section row-fluid panel two-panel qa-panel'
        },
        _react2.default.createElement('div', { className: 'ua-anchor ua-subsection-anchor', id: id }),
        headline && headline.text && _react2.default.createElement(
          'header',
          { className: 'containerCentered container text-left' },
          _react2.default.createElement(
            'div',
            { className: 'span12 col-sm-12' },
            _react2.default.createElement(
              'h3',
              { className: 'pulloutHeadline text-left' },
              htmlToReactParser.parse(headline.text)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'containerCentered container' },
          _react2.default.createElement(
            'div',
            { className: 'span12 col-sm-12' },
            paragraph && paragraph.text && _react2.default.createElement(
              'p',
              { className: 'contentPara' },
              htmlToReactParser.parse(paragraph.text)
            ),
            htmlToReactParser.parse(table.text),
            paragraph2 && paragraph2.text && _react2.default.createElement(
              'p',
              { className: 'contentPara' },
              htmlToReactParser.parse(paragraph2.text)
            )
          )
        )
      );
    }
  }]);

  return UASubSection;
}(_react2.default.Component);

exports.default = UASubSection;


UASubSection.propTypes = {
  sectionIndex: _propTypes2.default.number.isRequired,
  // setSubSection: PropTypes.func.isRequired,
  index: _propTypes2.default.number.isRequired,
  // scrollDirection: PropTypes.string.isRequired,
  anchorLink: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  headline: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  paragraph: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  table: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  paragraph2: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  })
};

UASubSection.defaultProps = {
  anchorLink: {
    text: ''
  },
  headline: {
    text: ''
  },
  paragraph: {
    text: ''
  },
  table: {
    text: ''
  },
  paragraph2: {
    text: ''
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/user-agreement/jsx/UASubSection.js
// module id = 1156
// module chunks = 4